import { render, staticRenderFns } from "./VentasSemanales.vue?vue&type=template&id=94b298f2&"
import script from "./VentasSemanales.vue?vue&type=script&lang=js&"
export * from "./VentasSemanales.vue?vue&type=script&lang=js&"
import style0 from "./VentasSemanales.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports